import ExpansionPanel from '@material-ui/core/ExpansionPanel';

/** @deprecated  Exporting the ExpansionPanel component from the material-ui library. */
export default ExpansionPanel;
